import React from "react";
import PageLayout from "../Layouts/PageLayout";
import { Button, Container } from "react-bootstrap";
import "../Styles/Admin.css";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import SearchIcon from "../Assets/Icons/searchIcon.svg";
import Pagination from "react-bootstrap/Pagination";
import ExportIcon from "../Assets/Icons/exportIcon.svg";
import SubscribeTable from "../Components/SubscribeTable";

export default function PaymentHistoryPage() {
  return (
    <Container fluid>
      <PageLayout>
        <div>
          <div style={{ marginTop: "1rem" }} className="merchant-parent">
            <h1 className="customer-heading">Merchant Subscribtion Payment History (100)</h1>
            <div className="merchant-table-card-con">
              <div style={{display: 'flex', alignItems: 'center', gap: '0.90rem', justifyContent: 'flex-end'}}>
                <div className="merchant-table-input">
                  <InputGroup style={{ width: "26rem" }} className="mb-3">
                    <Form.Control
                      placeholder="Search by name, email"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{
                        borderRight: "none",
                        height: "2.6rem",
                        fontSize: "0.90rem",
                      }}
                      className="shadow-none"
                    />
                    <InputGroup.Text
                      style={{ backgroundColor: "transparent" }}
                      id="basic-addon1"
                    >
                      <img style={{width: '1.2rem', height: '1.2rem'}} src={SearchIcon} />
                    </InputGroup.Text>
                  </InputGroup>
                </div>
                <Button
                  style={{
                    backgroundColor: "white",
                    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.32)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.50rem",
                    marginTop: "-17px"
                  }}
                  variant="light"
                >
                  <img
                    style={{ width: "1.5rem", height: "1.5rem" }}
                    src={ExportIcon}
                  />
                  Export
                </Button>
              </div>
              <SubscribeTable />
              <div className="pagination-con">
                <Pagination>
                  <Pagination.Prev />
                  <Pagination.Item>{1}</Pagination.Item>
                  <Pagination.Item>{2}</Pagination.Item>
                  <Pagination.Next />
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
